import styled from 'styled-components';

const SectionTitle = styled.h2`
    font-size: 2rem;
    display: block;
    padding-bottom: 0.5rem;
    text-align: center;
    font-weight: 300;
    text-transform: uppercase;
    letter-spacing: 2px;
    font-family: 'Lato', sans-serif;
    color: #FFFFFF;

&:after {
content: "";
    height: 3px;
    width: 5rem;
    background: #ffbc00;
    display: block;
    margin: 1rem auto;
}
`;

export default SectionTitle;
